import { render, staticRenderFns } from "./accountSettings.vue?vue&type=template&id=390f4728"
import script from "./accountSettings.vue?vue&type=script&lang=js"
export * from "./accountSettings.vue?vue&type=script&lang=js"
import style0 from "./accountSettings.vue?vue&type=style&index=0&id=390f4728&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports